import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { X } from "react-bootstrap-icons";
import Cookies from "js-cookie";
import newsLang from "../../i18n/news";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "0",
    border: "none",
  },
  overlay: {
    background: "rgba(0,0,0,0.5)",
  },
};

const PopupComponent = ({ children, locale, name }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (Cookies.get(name) === undefined) {
        setShow(true);
      }
    }, 5000);
  }, []);

  const closeModal = (value) => {
    setShow(false);
    if (value === "dont_show") Cookies.set(name, false);
  };

  return (
    <>
      <Modal
        isOpen={show}
        onRequestClose={closeModal}
        style={customStyles}
        ariaHideApp={false}
        className="col-10 col-md-8 col-xl-6"
      >
        <button
          className="btn btn-link btn-lg position-absolute text-white p-0"
          style={{ top: "5px", right: "5px", zIndex: 1 }}
          onClick={() => closeModal("close")}
        >
          <X className="lg-text-size" />
        </button>
        <button
          className="btn btn-link btn-lg position-absolute text-white p-0"
          style={{ bottom: "2px", right: "7px", zIndex: 1, fontSize: "13px" }}
          onClick={() => closeModal("dont_show")}
        >
          {newsLang.popupForm.show[locale]}
        </button>
        {children}
      </Modal>
    </>
  );
};

export default PopupComponent;
